/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const PinPlusIconOutline = createIcon({
  displayName: 'PinPlusIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.5,10c0,4.411 5.014,9.166 6.843,10.754c0.379,0.329 0.936,0.329 1.315,0c1.828,-1.588 6.842,-6.343 6.842,-10.754c0,-3.866 -3.358,-7 -7.5,-7c-4.142,0 -7.5,3.134 -7.5,7Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12,7.5v6"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15,10.5h-6"
        ></path>
      </g>
    </>
  ),
})

const PinPlusIconTwoTone = createIcon({
  displayName: 'PinPlusIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.5,10c0,4.411 5.014,9.166 6.843,10.754c0.379,0.329 0.936,0.329 1.315,0c1.828,-1.588 6.842,-6.343 6.842,-10.754c0,-3.866 -3.358,-7 -7.5,-7c-4.142,0 -7.5,3.134 -7.5,7Z"
        />
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,7.5v6"
        />
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15,10.5h-6"
        />
      </g>
    </>
  ),
})

const PinPlus: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={PinPlusIconTwoTone} {...props} />
    default:
      return <CustomIcon as={PinPlusIconOutline} {...props} />
  }
}

export default memo(PinPlus)
